<div>
  <div class="under-maintenance-container background-fill-container">
    <div class="container">
        <div class="text-container col-sm-12 col-md-6 col-lg-6 col-xl-8">
          <div style="font-weight: 600;font-size: 24px;line-height: 33px;color: #13223C;" ><adp-label labelKey="UnderMaintenance_heading"></adp-label></div>
          <div style="font-weight: 400;font-size: 16px;line-height: 28px;color: #3D515A;"><adp-label labelKey="UnderMaintenance_message"></adp-label></div>
        </div>
        <div class="image-container col-sm-12 col-md-6 col-lg-6 col-xl-8">
          <adp-image class="profile-img" aria-hidden="true" imageKey="Global_UnderMaintenance_Image"></adp-image>
        </div>
    </div>
  </div></div>